<template>
  <el-dialog width="40%" :visible="show" @close="closeDialog">
    <!-- 錯誤訊息popup -->
    <el-dialog
      width="30%"
      :title="alertMessage"
      :visible.sync="messageVisible"
      append-to-body>
      <div style="text-align:center">
        <el-button round type="danger" icon="now-ui-icons" @click="messageVisible=false">
          確認
        </el-button>
      </div>
    </el-dialog>
    <!-- 清算/凍結/解凍 popup -->
    <el-dialog
      width="30%"
      :title="actionMessage"
      :visible.sync="actionVisible"
      append-to-body
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div style="text-align:center">
        <el-button round type="" icon="now-ui-icons" :disabled="processing" @click="actionVisible=false">
          取消
        </el-button>
        <el-button round type="danger" icon="now-ui-icons" :disabled="processing" :loading="processing" @click="onActionConfirmed">
          確認
        </el-button>
      </div>
    </el-dialog>
    <template slot="title">
      <h5>儲值帳戶</h5>
    </template>
    <div>
    <el-table :data="tableDataItems" :show-header="false">
      <el-table-column prop="billingAccountId" label="billingAccountId">
         <template slot-scope="{row}">
          <el-row> 
            <el-col :span="8">{{row.label}}</el-col>
            <el-col v-if="row.html" :span="16" style="text-align:right" v-html="row.value"></el-col>
            <el-col v-else :span="16" style="text-align:right" v-html="row.value">{{row.value}}</el-col>
          </el-row>
         </template> 
         
      </el-table-column>
    </el-table>
    <br/>
    <div style="text-align:center">
      <!-- <el-button round type="warning" icon="now-ui-icons" 
        :disabled="this.accountData.panStatus !== 'blocked' || processing"
        :loading="action==='unblock' && processing"
        @click="onUnblockClick">
        申請解除凍結
      </el-button>
      <el-button round type="info" icon="now-ui-icons" 
        :disabled="this.accountData.panStatus !== 'activated' || processing" 
        :loading="action==='block' && processing"
        @click="onBlockClick" >
        申請凍結
      </el-button>
      <el-button round type="" icon="now-ui-icons"
        :disabled="!canClear" 
        :loading="action==='clear' && processing"
        @click="onClearClick">
        申請清算
      </el-button>
      <el-button round type="primary" icon="now-ui-icons" 
        :disabled="this.accountData.panStatus !== 'cleared' || processing" 
        :loading="action==='deactivate' && processing"
        @click="onDeactivateClick">
        關閉帳戶
      </el-button> -->
      <el-button round type="" icon="now-ui-icons"
        :disabled="!canClear" 
        :loading="action==='shutdown' && processing"
        @click="onShutdownClick">
        申請清算
      </el-button>
      <el-button round type="success" icon="now-ui-icons"
        :disabled="!canDelete" 
        :loading="action==='delete' && processing"
        @click="onDeleteClick">
        刪除帳戶
      </el-button>
      <el-button round type="danger" icon="now-ui-icons" @click="closeDialog">
        確認
      </el-button>
    </div>

    </div>
  </el-dialog>
</template>

<script>

import axios from 'axios';
import moment from 'moment';

export default {
  name: 'AccountDetail',
  props: {
    show: Boolean,
    baId: Number,
    account: {
      type: Object,
      default: function(){
        return {};
      }
    }
  },

  mounted() {
    if (this.baId)
      this.fetchBillingAccountData();
  },

  methods: {
    closeDialog() {
      this.$emit('update:show', false);
    },

    fetchBillingAccountData() {
      this.loading = true;
      // let apiHost = `https://apis-dev.ddc.ai/vas/v1/merchants/ddcstore/management/billing-accounts/${this.baId}`;
      // let apiHost = `http://localhost:3000/vas/v1/merchants/ddcstore/management/billing-accounts/${this.baId}`;
      let apiHost = `${process.env.VUE_APP_APIHOST}/${this.userType}/vas/merchants/ddcstore/billing-accounts/${this.baId}`;
      
      axios.get(
        `${apiHost}`
      )
      .then(response => {
        this.accountData = response.data;
        // this.accountData.shops = [{"shopId":"D_1LJd7kjE4","shopName":"測試-點點店"}]
      })
      .catch(err => {
        console.error(`[DialogAccountDetail] fetchBillingAccountData: fallback request failed as well`, err);
        let message;
        if (err.data && err.data.message)
          message = err.data.message;
        this.$notify.error({
          title: '無法取得此儲值帳戶詳細資料！',
          message: message || ''
        });
        this.accountData = {...this.account}
      })
      .finally(() => {
        this.loading = false;
      });
    },
    onShutdownClick () {
      console.log('try to shutdown billing account.')
     
      this.action = 'shutdown';
      this.actionMessage = '是否確定清算此帳戶，並進行退款？';
      this.actionVisible = true;
    },
    onClearClick () {
      console.log('try to clear billing account.')
      // TBD 檢查時間
     
      this.action = 'clear';
      this.actionMessage = '是否確定清算此帳戶，並進行退款？';
      this.actionVisible = true;
    },
    onBlockClick () {
      console.log('onBlockClick');
      if (this.accountData.panStatus !== 'activated') {
        this.alertMessage = '此帳戶不在啟用狀態，無法凍結。';
        this.messageVisible = true;
        return; 
      }
      this.action = 'block';
      this.actionMessage = '是否確定要暫時凍結此帳戶？';
      this.actionVisible = true;
    },
    onUnblockClick () {
      console.log('onUnblockClick');
      if (this.accountData.panStatus !== 'blocked') {
        this.alertMessage = '此帳戶不在凍結狀態，不需要取消凍結。';
        this.messageVisible = true;
        return; 
      }
      this.action = 'unblock';
      this.actionMessage = '是否確定解除凍結此帳戶？';
      this.actionVisible = true;
    },
    onDeactivateClick () {
      console.log('onDeactivateClick');
      if (this.accountData.panStatus !== 'cleared') {
        this.alertMessage = '請先進行清算，清空PAN帳戶並作消退後再關閉帳戶。';
        this.messageVisible = true;
        return; 
      }
      this.action = 'deactivate';
      this.actionMessage = '是否確定關閉此帳戶？';
      this.actionVisible = true;
    },
    onDeleteClick () {
      console.log('onDeleteClick');
      if (!this.canDelete) {
        this.alertMessage = '請先進行清算後再刪除帳戶。';
        this.messageVisible = true;
        return; 
      }
      this.action = 'delete';
      this.actionMessage = '是否確定刪除此帳戶？';
      this.actionVisible = true;
    },
    onActionConfirmed(){
      if (!this.action) {
        return;
      }
      this.processing = true;
      // let apiHost = `${process.env.VUE_APP_APIHOST}/${this.userType}/vas/merchants/ddcstore/billing-accounts/${this.baId}/deposit-records/${this.orderId}`;
      // let apiHost = `https://apis-dev.ddc.ai/vas/v1/merchants/ddcstore/billing-accounts/${this.baId}/records/${this.orderId}`;
      let action = '';
      let method = 'POST';
      let apiHost = '';
      switch(this.action) {
        case 'shutdown': // block + clear + deactivated
          action = '清算';
          apiHost = `${process.env.VUE_APP_APIHOST}/${this.userType}/vas/merchants/ddcstore/billing-accounts/${this.baId}/shutdown`;
          method = 'POST';
          break;
        case 'clear': 
          action = '清算';
          apiHost = `${process.env.VUE_APP_APIHOST}/${this.userType}/vas/merchants/ddcstore/billing-accounts/${this.baId}/clear`;
          // apiHost = `https://apis-dev.ddc.ai/vas/v1/merchants/ddcstore/billing-accounts/${this.baId}/clear`;
          method = 'POST';
          break;
        case 'block': 
          action = '凍結帳戶';
          apiHost = `${process.env.VUE_APP_APIHOST}/${this.userType}/vas/merchants/ddcstore/billing-accounts/${this.baId}/block`;
          // apiHost = `https://apis-dev.ddc.ai/vas/v1/merchants/ddcstore/billing-accounts/${this.baId}/block`;
          method = 'POST';
          break;
        case 'unblock': 
          action = '解除凍結帳戶';
          apiHost = `${process.env.VUE_APP_APIHOST}/${this.userType}/vas/merchants/ddcstore/billing-accounts/${this.baId}/unblock`;
          // apiHost = `https://apis-dev.ddc.ai/vas/v1/merchants/ddcstore/billing-accounts/${this.baId}/unblock`;
          method = 'POST';
          break;
        case 'deactivate': 
          action = '關閉帳戶';
          apiHost = `${process.env.VUE_APP_APIHOST}/${this.userType}/vas/merchants/ddcstore/billing-accounts/${this.baId}/deactivate`;
          // apiHost = `https://apis-dev.ddc.ai/vas/v1/merchants/ddcstore/billing-accounts/${this.baId}/deactivate`;
          method = 'POST';
          break;
        case 'delete': 
          action = '刪除帳戶';
          apiHost = `${process.env.VUE_APP_APIHOST}/${this.userType}/vas/merchants/ddcstore/billing-accounts/${this.baId}`;
          // apiHost = `https://apis-dev.ddc.ai/vas/v1/merchants/ddcstore/billing-accounts/${this.baId}`;
          method = 'delete';
          break;
        default:
          break;
      }
      axios.request({
        method: method,
        url: `${apiHost}`,
      })
      .then(response => {
        this.fetchBillingAccountData();

        this.$notify.success({
          title: `帳戶ID${this.accountData.id}，${action}完成。`
        });
        this.$emit('done');
      })
      .catch(err => {
        console.error(`[DialogAccountDetail] ${action} failed.`, err);
        let message;
        if (err.data && err.data.message)
          message = err.data.message;
        this.$notify.error({
          title: `帳戶ID${this.accountData.id}，${action}失敗！`,
          message: message || ''
        });
      })
      .finally(() => {
        this.action = null;
        this.actionVisible = false;
        this.processing = false;
      });
    }
  },

  data() {
    return {
      loading: false,
      accountData: {},
      alertMessage: '',
      messageVisible: false,
      action: null,
      actionMessage: '',
      actionVisible: false,
      processing: false,
    };
  },

  computed: {
    canClear(){
      if (this.accountData.status === 'active') {
        // 全部按鍵都開放
        // return this.accountData.panStatus === 'blocked' && !this.processing;
        return (this.accountData.panStatus !== 'none' && this.accountData.panStatus !== 'deactivated') && !this.processing
      } else {
        return false;
      }
    },
    canDelete () {
      return (this.accountData.panStatus === 'none' || this.accountData.panStatus === 'deactivated') 
        && this.accountData.status === 'active'
        && !this.cancelling;
    },
    tableDataItems () {
      if (!this.accountData) return [];
      let panStatus = null;
      switch(this.accountData.panStatus) {
        case 'pending':
          panStatus = '尚未啟用';
          break;
        case 'activated':
          panStatus = '已啟用';
          break;
        case 'deactivated':
          panStatus = '已關閉';
          break;
        case 'cleared':
          panStatus = '已清算關閉';
          break;
        case 'blocked':
          panStatus = '已暫時凍結';
          break;
        default:
          panStatus = this.accountData.panStatus
          break;
                    
      }
      let status = null;
      switch(this.accountData.status) {
        case 'deleted':
          status = '否';
          break;
        case 'active':
          status = '是';
          break;
        default:
          status = this.accountData.status
          break;
      }
      // let shops = '';
      // if (this.accountData.shops) {
      //   this.accountData.shops.forEach(element => {
      //     //shops += `${element.shopId} (${element.shopName}), `;
      //     shops += `${element.shopId}, `;
      //   });
      // }
      
      let displayItems = {
        billingAccountId: {
          label: '帳戶ID',
          show: true,
          value : this.accountData.id
        },
        billingAccountName: {
          label: '帳戶名稱',
          show: true,
          value : this.accountData.name
        },
        status: {
          label: '是否可儲值',
          show: true,
          value: status
        },
        
        shops: {
          label: '商店數量',
          show: true,
          value:  this.accountData.shops ? this.accountData.shops.length : 0
          //value : shops
        },
        ppAmount: {
          label: '剩餘儲值金（購買）',
          show: true,
          html: false,
          value : this.accountData.panId && this.accountData.pan ? Number(this.accountData.pan.balance.pp).toLocaleString() : ''
        },
        gpAmount: {
          label: '剩餘儲值金（贈送）',
          show: true,
          html: false,
          value : this.accountData.panId && this.accountData.pan ? Number(this.accountData.pan.balance.gp).toLocaleString() : ''
        },
        amount: {
          label: '剩餘儲值金（總額）',
          show: false,
          html: false,
          value : this.accountData.panId && this.accountData.pan ? 
            Number(this.accountData.pan.balance.gp + this.accountData.pan.balance.pp).toLocaleString()
            // `${Number(this.accountData.pan.balance.gp + this.accountData.pan.balance.pp).toLocaleString()}
            //   <br/>PP:${Number(this.accountData.pan.balance.pp).toLocaleString()}
            //   <br/>GP:${Number(this.accountData.pan.balance.gp).toLocaleString()}` 
            : ''
        },
        panStatus: {
          label: '帳戶狀態',
          show: true,
          // html: true,
          value: panStatus
        },
        email: {
          label: '帳戶聯絡人信箱',
          show: true,
          // html: true,
          value: this.accountData.pan ? this.accountData.pan.email : ''
        },
        panId: {
          label: 'PAN',
          show: true,
          value : this.accountData.panId
        },
      };

      let items = []
      for (const [key, value] of Object.entries(displayItems)) {
        if (value.show)
          items.push(value);
      }
      return items;

    },
    userType() {
      return this.$store.getters.userType;
    }
  },

  filters: {
    toDateTimeString(ts) {
      return moment.unix(ts).format('YYYY/M/D h:mmA');
    },
  },

  watch: {
    baId: function(id) {
      this.accountData = {};
      this.fetchBillingAccountData();
    }
  }
}
</script>

<style scoped>

</style>